import { amountsSavingInputNames, SAVING_ACTIONS } from '@dekafvv/sharedfrontend';
import { TSavingPlanSliceState } from './types';

export const initialState: TSavingPlanSliceState = {
    answers: {
        planSelection: {
            isGepValid: true,
        },
        amounts: {
            [amountsSavingInputNames.savingAction]: SAVING_ACTIONS.CREATE_MODIFY,
        },
        mtan: {},
    },
    fundings: [],
    portfolio: null,
    saving: null,
    validations: null,
    exAnteSavings: null,
    fundingId: null,
    fees: null,
    budgetarySurplus: null,
    budgetarySurplusRange: null,
};
